// extracted by mini-css-extract-plugin
export default {"selectCl":"SelectComponent_selectCl__JtYQG"};